export default __webpack_public_path__ + "static/media/confetti sound.f4c76861.mp3";